import { render, staticRenderFns } from "./CRMContacts.vue?vue&type=template&id=6a29b01c&scoped=true&"
import script from "./CRMContacts.vue?vue&type=script&lang=js&"
export * from "./CRMContacts.vue?vue&type=script&lang=js&"
import style0 from "./CRMContacts.vue?vue&type=style&index=0&id=6a29b01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29b01c",
  null
  
)

export default component.exports